/*
 * Globalize Culture fr-CH
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
    let Globalize;

    if (
        typeof require !== 'undefined' &&
        typeof exports !== 'undefined' &&
        typeof module !== 'undefined'
    ) {
        // Assume CommonJS
        Globalize = require('globalize');
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo('fr-CH', 'default', {
        name: 'fr-CH',
        englishName: 'French (Switzerland)',
        nativeName: 'français (Suisse)',
        language: 'fr',
        numberFormat: {
            ',': "'",
            NaN: 'Non Numérique',
            negativeInfinity: '-Infini',
            positiveInfinity: '+Infini',
            percent: {
                ',': "'",
            },
            currency: {
                pattern: ['$-n', '$ n'],
                ',': "'",
                symbol: 'fr.',
            },
        },
        calendars: {
            standard: {
                '/': '.',
                firstDay: 1,
                days: {
                    names: [
                        'dimanche',
                        'lundi',
                        'mardi',
                        'mercredi',
                        'jeudi',
                        'vendredi',
                        'samedi',
                    ],
                    namesAbbr: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
                    namesShort: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
                },
                months: {
                    names: [
                        'janvier',
                        'février',
                        'mars',
                        'avril',
                        'mai',
                        'juin',
                        'juillet',
                        'août',
                        'septembre',
                        'octobre',
                        'novembre',
                        'décembre',
                        '',
                    ],
                    namesAbbr: [
                        'janv.',
                        'févr.',
                        'mars',
                        'avr.',
                        'mai',
                        'juin',
                        'juil.',
                        'août',
                        'sept.',
                        'oct.',
                        'nov.',
                        'déc.',
                        '',
                    ],
                },
                AM: null,
                PM: null,
                eras: [{ name: 'ap. J.-C.', start: null, offset: 0 }],
                patterns: {
                    d: 'dd.MM.yyyy',
                    D: 'dddd d MMMM yyyy',
                    I: 'dddd d MMMM',
                    t: 'HH:mm',
                    T: 'HH:mm:ss',
                    f: 'dddd d MMMM yyyy HH:mm',
                    F: 'dddd d MMMM yyyy HH:mm:ss',
                    M: 'd MMMM',
                    Y: 'MMMM yyyy',
                },
            },
        },
    });
})(this);
